<template>
	<div class="animated fadeIn">
		<b-card>
			<div class="display-table full-width mb-2">
				<strong class="card-title">{{$route.meta.label}}</strong>
			</div>
			<b-row>
				<ResponseAlert ref="response" />
				<div class="col-sm-12 mb-3">
					<b-row>
						<div class="col-sm-6">
							<div class="input-group">
								<input type="text" placeholder="Pencarian nama" v-model="config.search.SearchTerm" v-on:keyup.enter="get()"
									class="form-control form-control-sm" />
								<div class="input-group-prepend">
									<div class="input-group-text" v-on:click="get()">
										<i class="fa fa-search"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6 d-flex justify-content-end">
							<router-link :to="'/'+config.uri+'/add'" 
								class="btn btn-primary">
								<i class="fa fa-plus"/> Tambah
							</router-link>
							<button type="button" @click="$bvModal.show('downloadModal')" class="btn btn-primary" >
								<i class="fa fa-download"/> Download
							</button>
						</div>
					</b-row>
				</div>
				<b-col sm="12">
					<div class="table-responsive">
						<table class="table b-table">
							<thead v-if="config.total_data">
								<tr>
									<th v-for="(row, key) in config.headers" :width="row.width" :key="key"
										:class="row.class">
										<a v-if="row.value" class="sort dark-font" v-on:click="sort(row.value)"
											href="javascript:void(0)">
											{{row.title}}
											<i :id="row.value" class="fa fa-sort"></i>
										</a>
										<a v-else class="sort dark-font" :id="row.value" href="javascript:void(0)">
											{{row.title}}
										</a>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-if="config.total_data">
									<tr v-for="(row, key) in config.rows" :key="key">
										<td>{{row.tglProses | formatDate}}</td>
										<td>{{row.fasilitasSumber ? row.fasilitasSumber.namaFasilitas : ""}}</td>
										<td>{{row.fasilitasTujuan ? row.fasilitasTujuan.namaFasilitas : ""}}</td>
										<td align="center">
											<router-link :to='`/${config.uri}/view/${row.id}`' title="Lihat"
												class="btn-action">
												<i class="fa fa-eye"></i>
											</router-link>
											<router-link :to='`/${config.uri}/edit/${row.id}`' title="Ubah"
												class="btn-action">
												<i class="fa fa-pencil"></i>
											</router-link>
											<button @click="destroy(row.id)" title="Hapus" class="btn-action">
												<i class="fa fa-trash"></i>
											</button>
										</td>
									</tr>
								</template>
								<tr v-if="!config.total_data">
									<td :colspan="config.headers.length" align="center"> Tidak ada data tersedia. </td>
								</tr>
							</tbody>
							<tfoot v-if="config.total_data">
								<tr>
									<td :colspan="config.headers.length" class="no-padding">
										<div class="pull-left table-information mt-25">
											<p>Menampilkan halaman {{config.page}} dari {{config.total_page}}</p>
										</div>
										<div class="pull-right pagination mt-25">
											<b-pagination @change="gotoPage" :total-rows="config.total_data"
												v-model="config.page" :per-page="config.per_page">
											</b-pagination>
										</div>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</b-col>
			</b-row>
		</b-card>
		<b-modal id="downloadModal" size="md" hide-footer hide-header>
			<form class="form-horizontal" @submit.prevent="download">
                <b-card class="position-relative">
                    <i class="fa fa-close btn-close-modal" @click="$bvModal.hide('downloadModal')"></i>
                    <h5 class="mb-4">Download</h5>
                    <b-row>
                        <b-col md="12" class="mb-2">
							<b-row>
								<b-form-group class="col-md-6" label="Tanggal Awal">
									<b-form-input type="date" v-model="models.StartDate" required>
									</b-form-input>
								</b-form-group>
								<b-form-group class="col-md-6" label="Tanggal Akhir">
									<b-form-input type="date" v-model="models.EndDate" required>
									</b-form-input>
								</b-form-group>
							</b-row>
							<div class="d-flex justify-content-end">
								<b-button type="submit" variant="primary" class="btn-min-width float-right">
									Download
								</b-button>
								<b-button type="button" @click="$bvModal.hide('downloadModal')" variant="default" class="btn-min-width float-right">
									Tutup
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-card>
			</form>
		</b-modal>
	</div>
</template>
<script>
	import table from '@/utils/table.js';
	import ResponseAlert from '@/components/response_alert';
	export default {
		name: 'ListB3Level2Kota',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
					api: "PenyimpananKota",
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					search: {
						SearchTerm: ""
					},
					headers: [{
						title: "Tgl Pemilahan",
						value: "tglProses",
						align: "text-left",
						width: "15%",
					}, {
						title: "Fasilitas Sumber",
						value: "fasilitasSumberId",
						align: "text-left",
						width: "20%",
					}, {
						title: "Fasilitas Tujuan",
						value: "fasilitasTujuanId",
						align: "text-left",
						width: "20%",
					}, {
						title: "Aksi",
						value: false,
						class: "text-center",
						width: "15%",
					}],
				},
				models: {
					StartDate: "",
					EndDate: "",
				}
			}
		},
		created() {
			const _ = this;
			_.get();
		},
		methods: {
			get() {
				table.get(this.config);
			},
			sort(orderby) {
				table.sort(this.config, orderby)
			},
			gotoPage(page) {
				table.gotoPage(this.config, page)
			},
			destroy(id) {
				const _ = this;
				_.$dialog.confirm('Anda yakin akan menghapus data ini?', {
					"okText": "Ya",
					"cancelText": "Tidak"
				}).then(() => {
					_.$axios.delete(`PenyimpananKota/${id}`)
					.then(res => {
						_.$refs.response.setResponse(res.data.message, 'success');
						_.get()
					})
				}).catch((error) => _.$refs.response.setResponse(error.response.data.message, 'danger'));
			},
			async download() {
				try {
					const _ = this;
					const response = await _.$axios.get(`PenyimpananKota/export`, {
						params: _.models,
						responseType: 'blob',
					});

					// Create a URL for the downloaded file
					const url = window.URL.createObjectURL(new Blob([response.data]));

					// Create a temporary <a> element to trigger download
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'PenyimpananKota.xlsx'); // Replace with the desired filename
					document.body.appendChild(link);
					link.click();

					// Clean up
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
					_.$bvModal.hide('downloadModal');
				} catch (error) {
					console.log(error);
					alert('Error downloading the file:', error);
				}
			}
		},
	}
</script>